<template>
  <div class="container-fluid">
    <template v-if="isLoading">
      <div class="pb-2">
        <skeleton-loading>
          <skeleton-square
            :box-properties="{
              height: '16px',
              width: '350px',
            }"
            :count="1"
          />
        </skeleton-loading>
      </div>
    </template>
    <template v-else>
      <h3>Partner - {{ getPartnerCourses.name }}</h3>
    </template>
    <div
      class="col-12 row justify-content-between container-instructors__search pr-0 pl-0 ml-0 mb-3"
    >
      <div class="col-7 pl-0">
        <form class="d-flex">
          <i class="fas fa-search fa-flip-horizontal"></i>
          <input
            v-model="search"
            aria-label="Search"
            class="form-control me-2"
            placeholder="Buscar por nombre"
            type="text"
            @keydown="searchCourses"
          />
        </form>
      </div>
    </div>
    <div class="container-instructors container-instructors__instructor px-0">
      <div class="container-fluid container-category px-0">
        <md-table>
          <md-table-row class="container-instructors__head">
            <md-table-head>Nombre del curso</md-table-head>
            <md-table-head>Precio</md-table-head>
            <md-table-head>Categoria</md-table-head>
            <md-table-head></md-table-head>
          </md-table-row>
          <template v-if="isLoading">
            <skeleton-partner-courses
              v-for="index in 4"
              :key="index"
            />
          </template>
          <template v-else>
            <md-table-row
              v-for="course in getPartnerCourses.partner_courses"
              :key="course.id"
              class="container-instructors__cell"
            >
              <md-table-cell>
                {{ course.name }}
              </md-table-cell>
              <md-table-cell>
                {{ course.free !== 0 ? 'Gratis' : course.price }}
              </md-table-cell>
              <md-table-cell>
                  <span>
                    {{
                      course.course_categories
                        .map((item) => item.course_category.title)
                        .join(', ')
                    }}</span
                  >
              </md-table-cell>
              <md-table-cell class="container-instructors__options">
              <span class="float-right">
                <md-menu md-size="auto" :md-offset-x="-147" :md-offset-y="-10">
                  <md-button md-menu-trigger>•••</md-button>

                  <md-menu-content>
                    <md-menu-item>
                      <router-link
                        class="dropdown-item-edit p-0"
                        :to="`/admin/cursos/curso/${course.id}`"
                      >
                        Editar
                      </router-link>
                    </md-menu-item>
                    <md-menu-item>
                      <div
                        class="dropdown-item p-0"
                        @click="openDeletePartnerCourseDialog(course)"
                      >
                        Eliminar
                      </div>
                    </md-menu-item>
                  </md-menu-content>
                </md-menu>
              </span>
              </md-table-cell>
            </md-table-row>
          </template>

        </md-table>
      </div>
    </div>
    <delete-dialog
      :is-open="isOpenDeletePartnerCourseDialog"
      @deleted="deletePartnerCourse"
      :is-loading="deletePartnerCourseLoading"
      @close-modal="closeDeletePartnerCourseDialog"
    />
  </div>
</template>

<script>
import { GET_PARTNER_COURSES } from '@/store/actions/partner';
import { mapGetters } from 'vuex';
import SkeletonSquare from '@/components/Skeleton/components/SkeletonSquare.vue';
import SkeletonLoading from '@/components/Skeleton/SkeletonLoading.vue';
import SkeletonPartnerCourses from '@/views/Components/skeletons/SkeletonPartnerCourses.vue';
import DeleteDialog from '@/views/Pages/Admin/components/DeleteDialog.vue';
import { UPDATE_COURSE } from '@/store/actions/course';

export default {
  components: {
    DeleteDialog,
    SkeletonPartnerCourses,
    SkeletonLoading,
    SkeletonSquare,
  },
  data: function() {
    return {
      selectedPartnerCourse: null,
      isOpenDeletePartnerCourseDialog: false,
      deletePartnerCourseLoading: false,
      isLoading: true,
      search: '',
    };
  },
  computed: {
    ...mapGetters(['getPartnerCourses']),
  },
  mounted () {

    this.fetchPartner();
  },
  methods: {
    async searchCourses (event) {
      if (event.key === 'Enter') {
        await this.refetchPartner();
      }
    },
    async refetchPartner () {
      this.isLoading = true;
      await this.fetchPartner();
    },
    async fetchPartner (
      filter = {
        id: this.$route.params.id,
        search_course: this.search,
      },
    ) {
      try {
        await this.$store.dispatch(GET_PARTNER_COURSES, filter);

      } catch (e) {

        this.notify(
          'danger',
          'Tenemos problemas para cargar los datos del socio',
        );
      }

      this.isLoading = false;
    },

    openDeletePartnerCourseDialog (course) {
      this.selectedPartnerCourse = course;
      this.isOpenDeletePartnerCourseDialog = true;
    },
    closeDeletePartnerCourseDialog () {
      this.selectedPartnerCourse = undefined;
      this.isOpenDeletePartnerCourseDialog = false;
    },
    async deletePartnerCourse () {
      const { id, name } = this.selectedPartnerCourse;
      this.deletePartnerCourseLoading = true;
      try {
        await this.$store
          .dispatch(UPDATE_COURSE, {
            partner_id: null,
            partner_percent: 0,
            id,
            name,
          });
        this.closeDeletePartnerCourseDialog();
        await this.refetchPartner();
      } catch (e) {
        this.notify('success', 'Se ha actualizado el socio con éxito');
      }

      this.deletePartnerCourseLoading = false;
    },
    notify (type, message) {
      this.$notify({
        type: type,
        verticalAlign: 'top',
        horizontalAlign: 'right',
        message: message,
      });
    },
  },
};
</script>

<style scoped>
.categories {
  border: none !important;
}

.dropdown-item {
  color: #000;
}

a.dropdown-item-edit {
  font-size: 14px !important;
  color: #000 !important;
  text-decoration: none;
}
</style>
